import {
  http
} from '../../config';
import base from '../base';

export const resignationApplication={
  applyTeaLeave(data){
    return http({
      url:`${base.record}/teaLeave/applyTeaLeave`,
      method:'post',
      data
    });
  },
  cancelApply(data){
    return http({
      url:`${base.record}/teaLeave/cancelApply`,
      method:'post',
      data
    });
  },
  queryLeaveInfo(data){
    return http({
      url:`${base.record}/teaLeave/queryLeaveInfo`,
      method:'post',
      data
    });
  },
  queryAgentTeaList(){
    return http({
      url:`${base.record}/teaLeave/queryAgentTeaList`,
      method:'get',
    });
  },
  queryApplyTeaList(){
    return http({
      url:`${base.record}/teaLeave/queryApplyTeaList`,
      method:'get',
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/agent-api/resignationApplication.js